module.exports = __webpack_public_path__ + "static/media/user.28287f14.webp";